module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Book-Of-Love-The.58b74b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Book-Of-Love-The.jpg
// module id = oUOo
// module chunks = 0